// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiURL: 'https://gsp-api.trusttags.in/',
  // apiURL: 'https://52.66.191.234:3010/',  
  // apiURL: 'http://gspdev-inline-api.trusttags.in/'
  //  apiURL: 'http://localhost:3007/',
  apiURL: 'https://gsp-api.trusttags.in/'
  //apiURL: 'http://gspdev-api.trusttags.in/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
